module.exports = __webpack_public_path__ + "img/strategy_mw.523db8ab.svg";